import React from "react";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

function DeleteBannerImage(props) {

  return (
    <BasicModal
      popupOpen={props?.deleteHotelChannelsPopUp}
      bodyMessage={<>
        <img src={deleteImg} alt="approve" className="w-40px" />
        <div className="delete-hotel mb-3">{props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData ?
          <div className="confirm-delete-hotel">
            <p>Do you really want to Delete Hotel Channels Configuration "<b>{props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}</b>" ?</p>
            <p className="warning"><IoMdWarning /> Warning</p>
            <p>Hotel Channels Configuration "{props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}" will be permanently deleted <br />
              Deleting the specified Hotel Channels Configuration can't be undone.
            </p>
            <p className="mt-3">To confirm deletion, type "Delete {props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}"</p>
            <div className="form-group-hotel mt-3">
              <div className="floating-label">
                <input
                  id="deleteHotel"
                  placeholder=''
                  onChange={(e) => props?.setConfirmDeleteHotelChannelsRow(e.target.value)}
                />
                <label htmlFor="deleteHotel">Delete {props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}</label>
              </div>
              {(props?.confirmDeleteHotelChannelsRow === "" && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}</small></p>
              ) : (props?.confirmDeleteHotelChannelsRow !== `Delete ${props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}` && props?.confirmValidate) ? (
                <p className="text-start"><small className="required">Please Enter Delete {props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData.row.channelName}</small></p>
              ) : ""
              }
            </div>
          </div> :
          props?.isHotelChannelsDeletedRef.current?.userConformationModalData?.successMessage}</div>
      </>
      }
      footer={
        props?.isHotelChannelsDeletedRef.current?.isHotelChannelsDeletedModalData ?
          {
            primaryButton: {
              buttonName: "Cancel",
              action: props?.popupCloseHandler
            }
            ,
            secondaryButton: {
              buttonName: "Delete",
              action: props?.deleteHotelChannelsHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: props?.popupCloseHandler
            }
          }
      }
    />
  );
}

export default DeleteBannerImage;
